import { useTranslation } from 'react-i18next';
import { Outlet, useMatch } from 'react-router';
import ROUTES from '@/routes';
import MyIndexRoute from '@/routes/my';
import cn from '@/utils/merge-class-names';
import ConditionalLayout from './conditional-layout';

export default function MyLayout() {
  const { t } = useTranslation();
  const isBatchMessage = useMatch(ROUTES.MY.SETTINGS.MESSAGING.BATCH.$path());
  return (
    <ConditionalLayout pathname={`${ROUTES.MY.$path()}`}>
      {(isDesktop, isMatch) => {
        if (isDesktop)
          return (
            <div className='inset-0 fixed z-40 flex justify-center items-center bg-black/75 backdrop-blur-sm'>
              <div className='w-[880px] max-h-[880px] h-90dvh rounded-lg overflow-hidden bg-neutral-0 flex flex-col'>
                <div className='bg-primary text-neutral-0 text-h2 py-4 px-6'>{t('mine.title')}</div>
                <div className='flex flex-1 overflow-hidden '>
                  <div className='grid grid-cols-[272px_1fr] grid-rows-[1fr] h-full w-full divide-x divide-metal-100 py-4'>
                    <div className={cn(isBatchMessage ? 'overflow-hidden' : 'overflow-auto')}>
                      <MyIndexRoute />
                    </div>
                    <div className='overflow-auto'>
                      <Outlet />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );

        return isMatch ? <MyIndexRoute /> : <Outlet />;
      }}
    </ConditionalLayout>
  );
}
